<h4>Graph Colour Scheme Presets</h4>

<mat-form-field appearance="fill" style="width:100%;">
  <mat-label>Select a Preset</mat-label>
  <mat-select [value]="widget?.colourScheme?.name" (valueChange)="onColourSchemeChange($event)">
    <mat-option>None</mat-option>
    <mat-option *ngFor="let colourSet of colorSets" [value]="colourSet.name">{{colourSet.name}}</mat-option>
  </mat-select>
</mat-form-field>

<div *ngIf="widget?.colourScheme != null" style="display: flex; float: left;">
  <span style="margin:auto;">Preview:</span>
  <span>
    <mat-icon *ngFor="let domain of widget.colourScheme.domain" [style.color]="domain">lens</mat-icon>
  </span>
</div>
